<template>
  <div>
    <!-- $store.state.dialogLogin -->
    <el-dialog title="" :visible.sync="$store.state.dialogLogin" width="fit-content" :show-close="false" :modal="true" :close-on-press-escape="true" :close-on-click-modal="true" custom-class="dialogBoxA" class="dialogcomPaddingtBox  noheaderPadding borderRadiu28" @closed="dialogClosed" @close="dialogClosed" @open="dialogOpen">
      <loginBox ref="loginBoxs" v-if="$store.state.dialogLogin"></loginBox>
    </el-dialog>
  </div>
</template>

<script>
import {getAjax, postAjax} from '@/api/index.js';
import loginBox from '@/page/login/components/loginBox'
import localStorageUtil from "../../../static/utils/localStorageUtil";
  export default{
    inject: ['reload'],
    data(){
      return{
        dialogLogin:false,
        registerStr: "",//预注册字符串
        isLoginPage:null,
      }
    },
    created(){
     let query = this.$route.query;
      if (query){
          if (query.w_code || query.w_state){
          // this.wapLoad(query.w_code,query.w_state) //微信扫码登录  则调用微信接口
          if(query.load_type == 'wx')this.wapLoad(query.w_code,query.w_state) //微信扫码登录  则调用微信接口
          if(query.load_type == 'qq')this.wapLoadQQLoad(query.w_code,query.w_state) //QQ扫码登录
          }
      }
    },
	mounted(){
		// window.addEventListener('keydown',this.keyDown);
	},
  methods:{
     openDialogLogin(loadType){
        this.loadType = loadType ? loadType : 'load';
        this.dialogLogin = true;
        this.$store.commit('setDialogLogin',true);
      },
    keyDown(e){
      // if(e.keyCode == 13){
      //   if(this.loadType == 'load'){
      //     this.load();
      //   }else if(this.loadType = 'binding'){
      //     this.bingdingCheck();
      //   }
      // }
    },
    dialogClosed(){
       this.$store.commit('setDialogLogin',false);
      window.removeEventListener('keydown',this.keyDown,false);
    },
    dialogOpen(){
      //   window.addEventListener('keydown',this.keyDown);
    },
    wapLoad(code,state){
        postAjax("/weChat/wapLoad",{code:code, state:state}).then((res)=> {
        if (res.code==1){
            this.optLoadPromise(res)
        }else if(res.code==200){
            this.openDialogLogin("binding");
            this.registerStr = res.data.registerStr;
            this.$nextTick(()=>{
              this.$refs.loginBoxs.registerStr=res.data.registerStr;
              this.$refs.loginBoxs.loadType='binding';
            })
            // this.$refs.loginBoxs.registerStr=res.data.registerStr

        }else{
            this.$message({type: 'error', message: res.msg ,duration:2000});
            this.clearWXQuery();//清除微信回调记录
        }
        });
    },
    wapLoadQQLoad(code,state){
      let web_redirect_uri = '';

      web_redirect_uri = window.location.href;
      postAjax("/index/QQ/wapLoad?code="+code+'&state='+state).then((res)=> {
          if (res.code==1){
              this.optLoadPromise(res)
          }else if(res.code==200){
              this.openDialogLogin("binding");
              this.registerStr = res.data.registerStr;
              this.$nextTick(()=>{
                this.$refs.loginBoxs.registerStr=res.data.registerStr;
                this.$refs.loginBoxs.loadType='binding';
              })
              // this.registerStr = res.data.registerStr;
              // console.log(this.registerStr)

          }else{
              this.$message({type: 'error', message: res.msg ,duration:2000});
              this.clearWXQuery();//清除微信回调记录
          }


      });

    },
    optLoadPromise(promise){
      if (!promise || promise.code != 1){
          this.$message({type: 'error', message: promise&&promise.ms ? promise.msg : '登录失败，请稍后再试!',duration:2000});
      } else {
          localStorageUtil.setCache("utoken", promise.data.utoken); //记录用户token
          localStorageUtil.setCache("utype", promise.data.utype); //记录用户token
          this.$store.commit('setUtoken', promise.data.utoken);
          this.getMyInfo();
          if (this.isloginPage) {
              this.$message({type: 'success', message: "登录成功！",duration:2000});
              let redirect = this.$route.query.redirect;
              if (redirect) {
              this.$router.replace({path: redirect});
              } else {
              if(promise.data.utype==1){
                  this.$router.replace({path: '/'})
              }else if(promise.data.utype==2){
                this.$router.replace({path: '/'})
              }

              }
          } else {
              this.$message({type: 'success', message:"登录成功！！",duration:2000});
              this.clearWXQuery();//清楚微信回调记录
              this.$store.commit('setDialogLogin',false);
              this.reload();

          }
      }
    },
    clearWXQuery(){
        let newQuery = JSON.parse(JSON.stringify(this.$route.query))
        if (newQuery.w_code || newQuery.w_state){
            //如果是微信扫码登录
            delete newQuery.w_code;
            delete newQuery.w_state;
            delete newQuery.load_type;
            this.$router.replace({query:newQuery});
        }
    },
    getMyInfo(){
      let user_name = this.$store.state.user_name;
      if (user_name == null ){
          getAjax("/index/member/getMemberInfo").then((res)=> {
              if (res.code ==1 ){
              //用户已登录
              this.$store.commit('setUserName', res.data.uname);
              this.$store.commit('setAdmin_url', res.data.automatic_logon_uri);
              this.$store.commit('setHeadimgurl', res.data.headimgurl);
              this.$store.commit('setBbs_status', res.data.bbs_status);
              this.$store.commit('setReply_status', res.data.reply_status);
              }else{
              //用户未登录 清除用户登录信息
              this.$store.commit('setUserName', null);
              this.$store.commit('setHeadimgurl', null);
              this.$store.commit('setAdmin_url',null);
              localStorageUtil.clearLoginStore();
              }
          });
      }
    },
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false);
  },
  components:{
    loginBox
  },
  watch:{
    dialogLogin(newVal,oldVal){
      if (newVal){
        window.addEventListener('keydown',this.keyDown);
      }else{
        window.removeEventListener('keydown',this.keyDown,false);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  // @import '~@/assets/css/login/login.scss'
</style>



// WEBPACK FOOTER //
// src/page/login/loginBox.vue